<script>
import { onMounted, ref } from "vue";
import tenantService from "@/services/super-admin/tenantService";

const columns = [
  {
    sorter: false,
  },
  {
    title: "Name",
    dataIndex: "Name",
    key: "Name",
    sorter: {
      compare: (a, b) => {
        a = a.Name.toLowerCase();
        b = b.Name.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Domain URL",
    dataIndex: "Domain_URL",
    sorter: {
      compare: (a, b) => {
        a = a.Domain_URL.toLowerCase();
        b = b.Domain_URL.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Provisioning",
    dataIndex: "Plan",
    sorter: {
      compare: (a, b) => {
        a = a.Plan.toLowerCase();
        b = b.Plan.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Created Date",
    dataIndex: "Created_Date",
    sorter: {
      compare: (a, b) => {
        a = a.Created_Date.toLowerCase();
        b = b.Created_Date.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Status",
    dataIndex: "Status",
    key: "Status",
    sorter: {
      compare: (a, b) => {
        a = a.Status.toLowerCase();
        b = b.Status.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "",
    key: "action",
    sorter: true,
  },
];

const rowSelection = {
  onChange: () => {},
  onSelect: () => {},
  onSelectAll: () => {},
};

export default {
  setup() {
    const data = ref([]);
    const loading = ref(false);

    const loadDomains = async () => {
      loading.value = true;
      try {
        const res = await tenantService.listDomains({ per_page: 100 });
        const rows = res?.data?.data || [];
        data.value = rows.map((row) => ({
          key: row.id,
          Image: "company-01.svg",
          Name: row.tenant?.company_name || row.tenant?.slug || "Tenant",
          Domain_URL: row.domain,
          Plan: row.tenant?.provisioning_status || "—",
          Created_Date: row.created_at
            ? new Date(row.created_at).toLocaleDateString()
            : "—",
          Status: row.tenant?.status || "Active",
          Workspace_URL: row.workspace_url || "",
          Legacy_Company_Id: row.tenant?.legacy_company_id || null,
          Data_Target: "#domain_approved",
        }));
      } catch (e) {
        data.value = [];
      } finally {
        loading.value = false;
      }
    };

    onMounted(loadDomains);

    return { data, loading };
  },
  data() {
    return {
      columns,
      rowSelection,
    };
  },
};
</script>

<template>
  <a-table
    class="table datatable thead-light"
    :columns="columns"
    :data-source="data"
    :row-selection="rowSelection"
  >
    <template #bodyCell="{ column, record }">
      <template v-if="column.key === 'Name'">
        <div class="d-flex align-items-center file-name-icon">
          <a href="javascript:void(0);" class="avatar avatar-md border rounded-circle">
            <img
              :src="require(`@/assets/img/company/${record.Image}`)"
              class="img-fluid"
              alt="img"
            />
          </a>
          <div class="ms-2">
            <h6 class="fw-medium">
              <a href="javascript:void(0);">{{ record.Name }}</a>
            </h6>
          </div>
        </div>
      </template>
      <template v-if="column.key === 'Status'">
        <a
          href="javascript:void(0);"
          :class="[
            'badge',
            record.Status === 'Approved'
              ? 'badge-soft-success'
              : record.Status === 'Pending'
              ? 'badge-soft-skyblue'
              : 'badge-soft-danger',
            'd-inline-flex',
            'align-items-center',
            'badge-xs',
          ]"
        >
          <i
            :class="[
              'ti',
              record.Status === 'Approved'
                ? 'ti-checks'
                : record.Status === 'Pending'
                ? 'ti-clock'
                : 'ti-x',
              'me-1',
            ]"
          ></i>
          {{ record.Status }}
        </a>
      </template>
      <template v-if="column.key === 'action'">
        <div class="action-icon d-inline-flex">
          <a
            v-if="record.Workspace_URL"
            :href="record.Workspace_URL"
            target="_blank"
            rel="noopener noreferrer"
            class="me-2"
            title="Open workspace"
            ><i class="ti ti-external-link"></i
          ></a>
          <a
            href="javascript:void(0);"
            class="me-2"
            data-bs-toggle="modal"
            :data-bs-target="record.Data_Target"
            ><i class="ti ti-eye"></i
          ></a>
          <a
            href="javascript:void(0);"
            data-bs-toggle="modal"
            data-bs-target="#delete_modal"
            ><i class="ti ti-trash"></i
          ></a>
        </div>
      </template>
    </template>
  </a-table>
</template>
